<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h360_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="$t('detailPage.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditViewForm"
          :model="dialogAddEditViewForm"
          :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              设置信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="是否有效样本"
                    required
                  >
                    <el-radio-group
                      v-model="dialogAddEditViewForm.isEfficient"
                    >
                      <el-radio
                        v-for="(item) in yesNoOptions"
                        :key="item.data"
                        :label="item.data"
                      >
                        {{ item.label }}
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogAddEditViewForm.isEfficient === 0"
                  :span="24"
                >
                  <el-form-item
                    label="无效原因"
                    prop="noEfficientReason"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.noEfficientReason"
                      type="textarea"
                      placeholder="请输入无效原因"
                      rows="3"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 数据请求
import { saveOrUpdateRetailSurveyItemApi, initRetailSurveyItemApi } from '@/api/retailSurveyInfo'
export default {
  components: { },
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      loading: true,
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {
        noEfficientReason: [ { required: true, message: '请输入无效原因', trigger: 'blur' }]
      },
      yesNoOptions: [{label: '有效', data: 1},{label: '无效', data: 0}]
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.dialogAddEditViewForm.clearValidate()
        })
        this.loading = true
        this.collectionPlanOptions = []
        this.collectionFrequencyOptions = []
        this.collectionProductOptions = []
        this.dialogAddEditViewForm = {
          id: null,
          isEfficient: 0,
          noEfficientReason: ''
        }
        this.initPageData()
      }
    }
  },
  methods: {
    // 加载数据
    initPageData () {
      initRetailSurveyItemApi({ id: this.dataId }).then(res => {
        const { item } = res.data
        for(let key in this.dialogAddEditViewForm) {
          this.dialogAddEditViewForm[key] = item[key]
        }
        this.loading = false
      })
    },
    // 加载数据
    reloadData () {
      this.$emit('reloadData')
    },
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave () {
      this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          this.$confirm(
            '是否确定保存有效性设置信息','系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText:'取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              this.loading = true
              if(this.dialogAddEditViewForm.isEfficient === 1) this.dialogAddEditViewForm.noEfficientReason = ''
              this.dialogAddEditViewForm.isEfficientSetting = 1
              this.saveOrUpdate()
            })
            .catch(() => { })
        }
      })
    },
    // 保存新增
    saveOrUpdate () {
      saveOrUpdateRetailSurveyItemApi(this.dialogAddEditViewForm).then(res => {
        if (res.mark === '200') {
          this.$message({ message: res.message, type: 'success' })
          this.reloadData()
          this.modalClose()
        }
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss"  scoped>

</style>
